const HistoryLogEnum={
  LOGIN_MEETING: 3,
  LOGOUT_MEETING: 5,
  JOIN_MEETING: 7,
  LEAVE_MEETING: 9
}
export default HistoryLogEnum